import axios from "axios";
import AuthUtil from '@/core/helpers/AuthUtil';
import { BACKEND_URL } from '@/core/config';

export const searchRequest = (body: {
  businessKey: string | null,
  status: number | null,
  iin: string | null,
  amount: string | null,
  currencyCode: string | null,
  actionType: string | null,
  lastname: string | null,
  firstname: string | null,
  middlename: string | null,
  phone: string | null,
  startDate: Date | null,
  endDate: Date | null,
  depId: string[] | number[] | null,
  initiator: string | null,
  afmStatus: number | null, // 0 - Не нужно отправлять, 1 - Нужно отправить, 2 - Сохранено, 3 - Подписано ЭЦП
  fromSum: number | null,
  toSum: number | null,
  kassaId: string | number | null
}) => {
  const auth = AuthUtil.getAuth();
  return axios
    .post(`${BACKEND_URL}/Application/search`,
      {
        ...body
      },
      {
        headers: {
          accept: "*/*",
          "Authorization": `Bearer ${auth.token?.accessToken}`
        },
      })
    .then((res: any) => res.data)
    .catch((e) => {
      console.error(e);
    });
};

export const getReportList = (page: number) =>
  axios
    .get(
      `${BACKEND_URL}/CashierReport/report?page=${page}`,
    )
    .then((res: any) => res.data)
    .catch(e => console.error(e));

export const getReport = (id: string) =>
  axios
    .get(
      `${BACKEND_URL}/CashierReport/report?reportId=${id}`,
    )
    .then((res: any) => res.data)
    .catch(e => console.error(e));